import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { api } from "@/api/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PaginationComponent } from "@/components/Pagination";
import { ConfirmDialog } from "@/components/ConfirmDialog";
import Header from "@/components/header";
import { useTranslation } from "@/locales";
import { toast } from "sonner";

// ag-grid-communityUI开始导入
import type { ColDef, ICellRendererParams } from "ag-grid-community";
// Core CSS
import { AG_GRID_LOCALE_HK } from "@ag-grid-community/locale";
import { AgGridReact } from "ag-grid-react";
import { themeQuartz } from "ag-grid-community"; // 从 ag-grid-community 导入
import { colorSchemeDarkWarm } from "ag-grid-community";

// 深色主题风格
// const themeDarkWarm = themeQuartz.withPart(colorSchemeDarkWarm);
const themeDarkWarm = themeQuartz.withPart(colorSchemeDarkWarm).withParams({
  backgroundColor: "#1d1d1d",
});
import pdfImage from "@/assets/search/pdf.png";
import mdImage from "@/assets/search/ic-MarkDown.svg";
import { useTheme } from "@/contexts/ThemeContext";
import { envStorage } from "@/utils/envCache";

// 定义表格数据类型
interface fileData {
  name: string;
  topicNo: React.Key | string | undefined;
  uid: number;
  topicName: string;
  createTime: string;
  email: string;
}
export default function HistoricalIssues() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [DialogData, setDialogData] = useState({
    title: "",
    description: "",
    confirmText: "",
  });

  // 在组件挂载后设置翻译
  useEffect(() => {
    setDialogData({
      title: t("admin.confirmDeleteTitle"),
      description: t("admin.confirmDeleteDescription"),
      confirmText: t("common.confirm"),
    });
  }, []);

  // 状态管理
  // 判断当前主题是否是深色模式
  const { resolvedTheme } = useTheme();
  const isDarkMode = resolvedTheme === "dark";
  //批量选中
  const [selectedRows, setSelectedRows] = useState<fileData[]>([]);
  const [data, setData] = useState<fileData[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  // 排序单独存储
  const [sortParams, setSortParams] = useState<{ sort: string; direction: string } | null>(null);

  // 用于上传人和核对人筛选
  const [creatorFilter, setCreatorFilter] = useState<string>("");
  const [checkerFilter, setCheckerFilter] = useState<string>("");

  // 手动搜索
  const handleManualSearch = () => {
    // 重置到第一页并重新获取数据
    setQueryParams((prev) => ({
      ...prev,
      page: 0,
    }));
    // getList();
  };

  // 重置搜索条件
  const handleReset = () => {
    setSearchTerm("");
    setCreatorFilter("");
    setCheckerFilter("");

    // 重置到第一页并重新获取数据
    setQueryParams((prev) => ({
      ...prev,
      page: 0,
    }));
    // setTimeout(() => {
    //     getList("");
    // }, 0);
  };
  //刷新
  const handleRefresh = () => {
    getList();
  };

  // 分页参数
  const [queryParams, setQueryParams] = useState<any>({
    page: 0,
    size: 30,
  });
  const [total, setTotal] = useState(0); // 总条数

  // 获取列表数据
  const getList = async (name?: any, passedSortParams?: { sort: string; direction: string }) => {
    try {
      setData([]);
      setLoading(true);

      // 如果没有传入排序参数，但有保存的排序参数，则使用保存的
      const finalSortParams = passedSortParams || sortParams;

      // 构建请求参数，包含所有当前的筛选条件
      const requestParams: any = {
        ...queryParams,
        topicName: name ? name : searchTerm || "",
        creatorUid: creatorFilter || "",
        checkerUid: checkerFilter || "",
        ...finalSortParams, // 添加排序参数
      };

      // 调用 GET 请求
      const response: any = await api.get("/v1/admin/topic/listing", {
        params: requestParams,
      });

      console.log(response);
      setData(response.content); // 存储接口返回的数据
      setTotal(response.page.totalElements);
    } catch (err) {
      console.error("获取文件列表失败:", err);
      setError("加载文件列表失败，请刷新页面重试");
    } finally {
      setLoading(false); // 无论成功失败，都结束加载状态
    }
  };

  const upList = async (page: number, limit: number) => {
    // 更新参数
    setQueryParams({
      ...queryParams,
      page: page,
      size: limit,
    });

    console.log(`获取第${page}页，每页${limit}条数据`);
  };
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (sortParams) {
        getList(searchTerm, sortParams);
      } else {
        getList(searchTerm);
      }
    }, 500);

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [queryParams.page, queryParams.size, queryParams]);

  // 在 useEffect 中统一处理过滤器事件
  useEffect(() => {
    // 统一处理所有过滤器变化
    const handleFilterChange = (event: CustomEvent) => {
      const { field, value } = event.detail;
      console.log(`Filter changed - ${field}:`, value);

      // 更新对应的查询参数，保留其他字段
      setQueryParams((prev) => {
        const newParams = { ...prev };

        if (value === undefined || value === null || value === "") {
          delete newParams[field];
        } else {
          (newParams as any)[field] = value;
        }

        return {
          ...newParams,
          page: 0,
        };
      });

      // if (sortParams) {
      //     setTimeout(() => {
      //         getList(searchTerm, sortParams);
      //     }, 0);
      // } else {
      //     setTimeout(() => {
      //         getList(searchTerm);
      //     }, 0);
      // }
    };

    // 添加事件监听器
    window.addEventListener("filterChanged", handleFilterChange as EventListener);

    return () => {
      // 清理事件监听器
      window.removeEventListener("filterChanged", handleFilterChange as EventListener);
    };
  }, [sortParams]);

  // 排序处理函数
  const onSortChanged = (event: any) => {
    const columnState = event.api.getColumnState();
    const sortedColumn = columnState.find((col: any) => col.sort);

    if (sortedColumn) {
      // 当有列被排序时，移除提示图标样式
      const style = document.getElementById("grid-sort-icons");
      if (style) {
        style.innerHTML = `.ag-header-cell[col-id="createTime"] .ag-header-cell-label::after{
                    display: none !important;
                }
            `;
      }

      let newSortParam = {};

      // 根据不同的列设置不同的sort参数
      if (sortedColumn.colId === "createTime") {
        newSortParam = {
          sort: "id",
          direction: sortedColumn.sort === "asc" ? "ASC" : "DESC",
        };
      } else if (sortedColumn.colId === "checkTime") {
        newSortParam = {
          sort: "checkTime",
          direction: sortedColumn.sort === "asc" ? "ASC" : "DESC",
        };
      } else {
        // 其他列使用默认处理
        setSortParams(null);
        getList(searchTerm);
        return;
      }

      // 保存排序参数
      setSortParams(newSortParam as { sort: string; direction: string });
      // 调用带排序参数的接口
      getList(searchTerm, newSortParam);
    } else {
      // 当没有列被排序时，恢复提示图标样式
      const style = document.getElementById("grid-sort-icons");
      if (style) {
        style.innerHTML = `.ag-header-cell[col-id="createTime"] .ag-header-cell-label::after{
                    content: " ⇅";
                    font-size: 14px;
                    opacity: 0.7;
                    margin-left: 5px;
                }
            `;
      }

      // 清除排序参数
      setSortParams(null);
      // 恢复默认排序
      getList(searchTerm);
    }
  };
  const handleDetail = (data: any) => {
    console.log(data);
    const currentUrl = window.location.href;
    const currentPathIndex = currentUrl.indexOf("#");
    const baseUrl = currentPathIndex !== -1 ? currentUrl.substring(0, currentPathIndex) : currentUrl.replace(/\/?$/, "/");
    const url = `${baseUrl}#/admin/topicDetail/${data.topicNo}`;

    console.log(url);
    window.open(url, "_blank");
  };

  const location = useLocation();
  // 当前路由的路径  现在暂时用路径判断，到最终用权限判断显示用户前端界面  还是管理后端的界面
  const currentPath = location.pathname;
  const admin = envStorage.getItem("admin") === "true";
  useEffect(() => {
    //监听标识变化，如果是用户，不给去管理后端
    if (!admin) {
      if (currentPath.indexOf("/admin") !== -1) {
        navigate("/", { replace: true });
      }
    }
  }, [admin]);

  const localeText = AG_GRID_LOCALE_HK;
  // 列表配置
  const [columnDefs, setColDefs] = useState<ColDef[]>([
    /* {
            headerName: '',
            field: 'checkbox',
            pinned: 'left',
            maxWidth: 50,
            sortable: false,
            checkboxSelection: true,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            cellStyle: { textAlign: 'center' },
            resizable: false,  // 禁止调整列宽
            suppressMovable: true,  // 禁止拖动列
            lockPosition: true,  // 锁定列位置
        },*/
    //floatingFilter: true  高级过滤
    {
      headerName: t("admin.originalQuestion"),
      field: "topicName",
      width: 600,
      maxWidth: 900,
      minWidth: 400,
      tooltipField: "topicName",
      cellRenderer: (params: ICellRendererParams) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            {/* 可省略的文本内容 */}
            <div
              onClick={() => handleDetail(params.data)}
              style={{
                flex: 1,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              <span style={{ color: "#0066cc", textDecoration: "underline", cursor: "pointer" }}>{params.value}</span>
            </div>
          </div>
        );
      },
      filterValueGetter: (params) => {
        return params.data.topicName;
      },
    },
    {
      headerName: t("admin.askingUser"),
      field: "email",
      maxWidth: 400,
      minWidth: 200,
      cellRenderer: (params: ICellRendererParams) => {
        //当使用自定义 cellRenderer 时，tooltipField 可能不会按预期工作。这是因为自定义渲染器覆盖了默认的单元格行为。
        const nickname = params.data.nickname || "";
        const email = params.data.email || "";

        // 合并两个值作为工具提示内容
        const tooltipText = nickname && email ? `${nickname}\n${email}` : nickname || email || "";
        return (
          <div style={{ display: "flex", flexDirection: "column", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={tooltipText}>
            <div style={{ height: "15px" }}>{nickname}</div>
            <div style={{ color: "gray", fontSize: "0.9em", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{email}</div>
          </div>
        );
      },
    },
    { headerName: t("admin.questionTime"), field: "createTime", maxWidth: 400, minWidth: 300, tooltipField: "createTime", sortable: true },
    {
      headerName: t("admin.actions"),
      width: 80,
      flex: 0,
      maxWidth: 80,
      sortable: false,
      suppressMovable: true, // 禁止拖动列
      pinned: "right",
      cellRenderer: (params: ICellRendererParams) => {
        return (
          <div className="text-blue-600" style={{ cursor: "pointer", marginLeft: "10px" }} onClick={() => handleDetail(params.data)}>
            {t("common.view")}
          </div>
        );
      },
      cellStyle: {
        textAlign: "center",
        padding: "5px",
      },
    },
  ]);

  const defaultColDef: ColDef = {
    flex: 1,
    // filter: true,
    sortable: false, //是否有排序
    // 允许单元格内容被选中
    cellStyle: {
      display: "flex",
      alignItems: "center",
      userSelect: "text", // 核心配置：允许文本被选中
      WebkitUserSelect: "text", // 兼容webkit内核浏览器
      MozUserSelect: "text", // 兼容Firefox
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    cellRenderer: (params: ICellRendererParams) => {
      return (
        <div
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {params.value}
        </div>
      );
    },
  };

  return (
    <div className="flex flex-col pl-4 pr-4 py-12 pt-0 dark:bg-[#1d1d1d] bg-[#ffffff]" style={{ width: "100%", overflow: "auto" }}>
      <style id="grid-sort-icons">
        {`.ag-header-cell[col-id="createTime"] .ag-header-cell-label::after{
                content: " ⇅";
                font-size: 14px;
                opacity: 0.7;
                margin-left: 5px;
            }`}
      </style>
      <Header title={t("admin.fileSet")} />
      <div className="space-y-4 flex-shrink-0">
        {/* <div className="flex flex-col md:flex-row justify-between items-start md:items-center mx-auto space-y-4 mt-5">
                    <div className="flex flex-wrap items-center gap-4 mb-0">
                        <div className="flex items-center">
                            <span className="whitespace-nowrap" style={{fontSize:'15px'}}>原始问题:</span>
                            <Input
                                style={{display:'inline-block',marginLeft:'10px',height:'32px'}}
                                placeholder="问题搜索..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && handleManualSearch()}
                                className="w-52 ml-2"
                            />
                        </div>

                        <div className="flex items-center">
                            <span className="whitespace-nowrap" style={{fontSize:'15px'}}>核对人:</span>
                            <Select
                                value={checkerFilter}
                                onValueChange={setCheckerFilter}
                                disabled={isTeamUsersLoading}
                            >
                                <SelectTrigger className="w-40 ml-2">
                                    <SelectValue placeholder="请选择核对人" />
                                </SelectTrigger>
                                <SelectContent>
                                    {teamUsers.map((user) => (
                                        <SelectItem
                                            key={user.id}
                                            value={user.uid|| `user-${user.uid}`}
                                        >
                                            {user.nickname}
                                        </SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                        </div>
                        <div className="flex items-center gap-2">
                            <Button onClick={handleManualSearch}>搜索</Button>
                            <Button variant="outline" onClick={handleReset}>重置</Button>
                            <Button variant="outline" onClick={handleRefresh}>刷新</Button>
                        </div>
                    </div>

                    <div className="mt-2 md:mt-0" >
                        <Button onClick={() => uploadDialogRef.current?.open()}>
                            上传文件</Button>
                    </div>
                </div>*/}

        <div className="flex-grow ag-theme-alpine" style={{ height: "calc(100vh - 150px)", width: "100%" }}>
          <AgGridReact
            theme={isDarkMode ? themeDarkWarm : themeQuartz} //themeQuartz 默认主题风格
            columnDefs={columnDefs}
            rowData={data}
            defaultColDef={defaultColDef}
            rowHeight={50}
            localeText={localeText}
            onSortChanged={onSortChanged} // 添加排序变化监听
            rowSelection="multiple"
            onSelectionChanged={(event) => {
              const selectedNodes = event.api.getSelectedNodes();
              const selectedData = selectedNodes.map((node) => node.data);
              setSelectedRows(selectedData);
            }}
            suppressRowClickSelection={true}
            // 加载状态相关属性
            loadingOverlayComponent={() => (
              <div className="ag-custom-loading">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    flexDirection: "column",
                  }}
                >
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mb-2"></div>
                  <span>{t("common.loading")}</span>
                </div>
              </div>
            )}
            loadingOverlayComponentParams={{
              loadingMessage: t("common.loading"),
            }}
            noRowsOverlayComponent={() => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  padding: "20px",
                }}
              >
                <div>{t("common.noData")}</div>
              </div>
            )}
            // 控制何时显示加载状态
            loading={loading}
          />
        </div>
      </div>
      {/* 分页组件 */}
      {total > 0 && (
        <div className="flex-shrink-0 dark:bg-[#1d1d1d] bg-[#ffffff]">
          <PaginationComponent total={total} page={queryParams.page} limit={queryParams.size} pageSizes={[30, 40, 50]} onPagination={upList} prevNextType="icon" />
        </div>
      )}
    </div>
  );
}
